import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from '../../api/order.service';
import { CreateNewModalComponent } from '../../modal/create-new-modal/create-new-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { interval } from 'rxjs';
import { UpdateService } from 'src/app/api/update.service';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { IspAcceptRejectComponent } from '../../components/isp-accept-reject/isp-accept-reject.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit {

  public sidebarOpened = false;
  public userInfo: any = {};
  public modalRef: any;
  public searchOrderNo: any;
  public showAll: any;
  public imgServerPath: any;
  public orderSearchFilter = {
    filters: {

    }
  };

  public url:String;
  toggleOffcanvas() {
    this.sidebarOpened = !this.sidebarOpened;
    if (this.sidebarOpened) {
      document.querySelector('.sidebar-offcanvas').classList.add('active');
    } else {
      document.querySelector('.sidebar-offcanvas').classList.remove('active');
    }
  }

  constructor(private config: NgbDropdownConfig, private router: Router,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private orderService: OrderService, private updateService: UpdateService) {
    config.placement = 'bottom-right';
    this.showAll = [];
    this.getAllNotifications();
    interval(100000).subscribe(x => {
      this.getAllNotifications();
    } );
  }

  ngOnInit() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.imgServerPath = environment.imageServerPath;

    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          // console.log('this.router.url', this.router.url);
          this.url = this.router.url
        }
      }
    );
  }

  onLogout() {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    this.router.navigateByUrl('/login');
  }

  getAllNotifications() {
    this.showAll = [];
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (this.userInfo && this.userInfo.id) {
      this.updateService.getAllNotificationWithoutFilter().subscribe(res => {
        for (let notification of res.data) {
          this.showAll.push(this.getNotificationList(notification));
        }
      });
    }
  }

  getNotificationList(notification) {
    let update = {};
    var name = notification.acted_by_name;
    var acronym = 'US';
    if (name) {
      var matches = name.match(/\b(\w)/g);
      acronym = matches.join('').toUpperCase();
    }
    update['desc1'] = acronym;
    update['desc2'] = notification.message;
    update['desc3'] = moment(notification.createdAt).format('DD/MM/YYYY h:mm A');
    update['desc4'] = '#f2994a';
    update['notification_id'] = notification.id;
    update['type'] = notification.type;
    update['type_id'] = notification.type_id;
    if(notification.order) {
      update['priority'] = notification.order.priority;
      update['desc4'] = (notification.order.priority == 'High Priority') ? '#EA4051' : '#5A8E18';
    }
    return update;
  }

  openModel() {
    this.modalRef = this.modalService.open(IspAcceptRejectComponent,
      { windowClass : 'customOrderModel', backdrop: 'static', keyboard: false });
  }

  searchOrder() {
    let filters = {};
    if (JSON.parse(localStorage.getItem('userInfo')).role != 'admin') {
        filters['isp_user_id'] = JSON.parse(localStorage.getItem('userInfo')).id;
    }

    filters["orderNo"] = this.searchOrderNo
    this.orderService.searchOrder({filters : filters}).subscribe(res => {
      if (res.data.length != 0) {
          this.router.navigateByUrl('/order/view/' + res.data[0].id);
      } else {
        this.modalRef = this.modalService.open(CreateNewModalComponent);
        this.modalRef.componentInstance.my_modal_content = 'Order Not Found';
        this.modalRef.result.then((data: any) => {
          this.router.navigateByUrl(this.router.url);
        });
      }
    }, error => {
      this.modalRef = this.modalService.open(CreateNewModalComponent);
      this.modalRef.componentInstance.my_modal_content = ' Order Not Found';
      this.modalRef.result.then((data: any) => {
        this.router.navigateByUrl(this.router.url);
      });
    });
  }

  navigateRoutePage() {
    if (this.userInfo.role === 'isps' || this.userInfo.role === 'asms' || this.userInfo.role === 'bsms' || this.userInfo.role === 'rsms' || this.userInfo.role === 'hos') {
       this.router.navigateByUrl('/dashboard');
    } else {
      this.router.navigateByUrl('/job-orders');
   }
  }

  readClickedNotification(update) {
    let notification = {
      'notification_id' : update.notification_id,
      'user_id' : JSON.parse(localStorage.getItem('userInfo')).id
    };
    this.updateService.readNotification(notification).subscribe(res => {
      this.getAllNotifications();
      if (update.type === 'order') {
        this.router.navigateByUrl('/order/view/' + update.type_id);
      } else if (update.type === 'user') {
        this.router.navigateByUrl('/user/view/' + update.type_id);
      }
    });
  }

}
